import React from 'react';
import PropTypes from 'prop-types';

const TableLegends = ({ fields, getTranslation }) => {
    const legendIcon = PULSE.app.templating.render(
        {
            cssClass: '',
            name: 'info'
        },
        'common.svg-icon'
    );

    const extraFields = [
        {
            fieldLabelShort: 'label.bye.short',
            fieldLabel: 'label.bye'
        }
    ];

    return (
        <aside className="legend">
            <h3 className="legend__title">
                <span dangerouslySetInnerHTML={{ __html: legendIcon }}></span>
                {getTranslation('label.legend')}
            </h3>
            <ul className="legend__list">
                {[...fields, ...extraFields].map(
                    (field, i) =>
                        field.fieldLabelShort &&
                        field.fieldLabel && (
                            <li
                                key={`legend__list__${i}`}
                                className="legend__item"
                            >
                                <strong>
                                    {getTranslation(field.fieldLabelShort)}:
                                </strong>{' '}
                                {getTranslation(field.fieldLabel)}
                            </li>
                        )
                )}
            </ul>
        </aside>
    );
};

TableLegends.propTypes = {
    fields: PropTypes.array.isRequired,
    getTranslation: PropTypes.func.isRequired
};

export default TableLegends;
